import { ComponentChildren } from 'preact';
import { CalUserMenu } from './cal-user-menu';

/**
 * Common layout wrapper for public calendar pages
 * Provides consistent header with user account menu
 */
export function CalPublicLayout({ children }: { children: ComponentChildren }) {
  return (
    <div class="p-2 flex flex-col bg-gray-100 min-h-screen">
      <header class="flex justify-end p-4 mb-2">
        <CalUserMenu />
      </header>

      <div class="flex items-center justify-center flex-grow">{children}</div>
    </div>
  );
}
